import { render, staticRenderFns } from "./AddToCartSidebar.vue?vue&type=template&id=2909a293"
import script from "./AddToCartSidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddToCartSidebar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AddToCartSidebar.vue?vue&type=style&index=0&id=2909a293&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports